const hotTopics = [
  { rank: 1, name: "顾言泽", topic: "巡演两场回应措辞前后矛盾？网友在做逐条对照", views: "48.6万", heat: 96, tag: "明星" },
  { rank: 2, name: "桃桃酱", topic: "带货同款链接反复上下架，评论区开始对账", views: "37.2万", heat: 88, tag: "网红" },
  { rank: 3, name: "电竞KK", topic: "早期直播片段被挖出，文字稿已有人整理完", views: "29.8万", heat: 81, tag: "主播" },
  { rank: 4, name: "老铁阿贵", topic: "事件完整时间线整理贴，已有人做成长图", views: "21.4万", heat: 74, tag: "网红" },
  { rank: 5, name: "沈嘉茉", topic: "剧组合作疑云，关联人物名单持续更新", views: "18.1万", heat: 69, tag: "明星" },
  { rank: 6, name: "林岳", topic: "合同细节逐条解释，真假参半引大讨论", views: "12.7万", heat: 63, tag: "公众人物" },
  { rank: 7, name: "麻辣丸子", topic: "早年带货素材征集帖，楼里有人补了图", views: "9.6万", heat: 55, tag: "网红" },
  { rank: 8, name: "深夜阿宁", topic: "电台言论时间线，已归档部分被反复引用", views: "7.8万", heat: 47, tag: "主播" },
];

export default function HotRank() {
  return (
    <section id="hot" className="mx-auto w-full max-w-6xl scroll-mt-24 px-4 py-10 md:py-14">
      <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
        <div>
          <p className="mb-1 flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-500">
            <span className="inline-block h-px w-6 bg-primary-400" />
            HOT
          </p>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            热议热榜 · 谁的瓜在看的人最多
          </h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-500">
            按围观讨论度排序，榜单每小时更新一次。点进话题，能看到围绕这位人物各条黑料条目的讨论汇总。
          </p>
        </div>
        <span className="flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-800">
          <i className="ri-time-line" /> 每小时更新
        </span>
      </div>

      <div className="mt-7 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
        {hotTopics.map((t) => (
          <div
            key={t.rank}
            className="group flex flex-col gap-3 border-b border-background-100 px-4 py-4 transition-colors last:border-0 hover:bg-background-100/50 md:flex-row md:items-center"
          >
            <div className="flex w-full items-center gap-4 md:w-[420px] md:shrink-0">
              <span
                className={`font-heading w-8 shrink-0 text-center text-xl font-black ${
                  t.rank <= 3 ? "text-primary-500" : "text-foreground-300"
                }`}
              >
                {String(t.rank).padStart(2, "0")}
              </span>
              <div className="min-w-0">
                <h3 className="cursor-pointer truncate text-[16px] font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {t.topic}
                </h3>
                <p className="mt-0.5 text-xs text-foreground-400">
                  人物：<b className="font-medium text-foreground-600">{t.name}</b>
                  <span className="ml-2 rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-700">{t.tag}</span>
                </p>
              </div>
            </div>

            <div className="flex flex-1 items-center gap-3 md:pl-4">
              <div className="hidden h-1.5 w-full max-w-xs flex-1 overflow-hidden rounded-full bg-background-200 md:block">
                <div
                  className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                  style={{ width: `${t.heat}%` }}
                />
              </div>
              <span className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500">
                <i className="ri-eye-line text-primary-500" /> {t.views} 围观
              </span>
              <div className="ml-auto flex shrink-0 gap-2">
                <button
                  type="button"
                  className="flex items-center gap-1 whitespace-nowrap rounded-full border border-background-200 px-3 py-1.5 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className="ri-chat-3-line" /> 讨论
                </button>
                <button
                  type="button"
                  className="flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1.5 text-xs font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-eye-line" /> 围观
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}